module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("caRC9"))).then(() => parcelRequire('hEqeo'));